import { Helmet } from "react-helmet-async";
import React, { useEffect, useState } from "react";
import { listNews } from "../lib/db";
import { Link } from "react-router-dom";

export default function News() {
  const [news, setNews] = useState([]);
  useEffect(() => {
    listNews().then(setNews).catch(() => {});
  }, []);

  return (
    <div data-testid="news-page">
      <Helmet>
  <title>News – ASD Rubiana Calcio</title>
  <meta name="description" content="Tutte le ultime notizie dell'ASD Rubiana Calcio: risultati, aggiornamenti sulla squadra, eventi della palestra e news dalla Val di Susa." />
  <meta property="og:title" content="News – ASD Rubiana Calcio" />
  <meta property="og:description" content="Ultime notizie, risultati e aggiornamenti dell'ASD Rubiana Calcio." />
  <meta property="og:url" content="https://rubianacalcio.it/news" />
  <meta property="og:type" content="website" />
  <meta property="og:image" content="https://rubianacalcio.it/logo512.png" />
</Helmet>
      <section className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pt-20 pb-12 border-b border-zinc-900">
        <div className="text-overline text-yellow-400 mb-4">// Magazine</div>
        <h1 className="font-display font-black text-5xl sm:text-7xl tracking-tighter uppercase leading-none">News & storie</h1>
      </section>

      <section className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
        {news.length === 0 && <p className="text-zinc-500">Nessun articolo disponibile.</p>}
        {news.map((n, idx) => (
          <Link
            to={`/news/${n.id}`}
            key={n.id}
            className={idx === 0 ? "lg:col-span-2 lg:row-span-2" : ""}
          >
            <article
              className="rounded-2xl overflow-hidden bg-zinc-900 border border-zinc-800 hover:border-yellow-400/40 transition-all group cursor-pointer h-full"
              data-testid={`news-${n.id}`}
            >
              <div className={`overflow-hidden ${idx === 0 ? "aspect-[16/9]" : "aspect-[16/10]"}`}>
                <img src={n.image} alt={n.title} className="h-full w-full object-cover group-hover:scale-105 transition-transform duration-700" />
              </div>
              <div className="p-6">
                <div className="flex items-center gap-3 mb-3">
                  <span className="text-overline text-yellow-400">{n.category}</span>
                  <span className="text-xs text-zinc-500">{new Date(n.published_at).toLocaleDateString("it-IT", { day: "numeric", month: "long", year: "numeric" })}</span>
                </div>
                <h3 className={`font-display font-bold leading-tight mb-3 group-hover:text-yellow-400 transition-colors ${idx === 0 ? "text-3xl" : "text-xl"}`}>{n.title}</h3>
                <p className="text-sm text-zinc-400 leading-relaxed">{n.excerpt}</p>
              </div>
            </article>
          </Link>
        ))}
      </section>
    </div>
  );
}